import { httpRequest } from '@/services/httpClient'

export type LookupItem = {
  id: number
  tenantId: number | null
  code: string
  name: string
  description: string | null
  color: string | null
  sortOrder: number
  isActive: boolean
  createdAt: string
  updatedAt: string | null
}

export type LookupListResponse = {
  items: LookupItem[]
  totalCount: number
  page: number
  pageSize: number
}

export type LookupListParams = {
  tenantId?: number
  search?: string
  page?: number
  pageSize?: number
  sortBy?: 'code' | 'name'
  sortDir?: 'asc' | 'desc'
}

export type LookupCreateUpdatePayload = {
  tenantId?: number | null
  code: string
  name: string
  description?: string | null
  color?: string | null
  sortOrder?: number
  isActive?: boolean
}

export function createLookupApi(basePath: string) {
  return {
    list: (params: LookupListParams) =>
      httpRequest<LookupListResponse>(`/v1/${basePath}`, {
        method: 'GET',
        query: {
          tenantId: params.tenantId,
          search: params.search?.trim() || undefined,
          page: params.page ?? 1,
          pageSize: params.pageSize ?? 50,
          sortBy: params.sortBy,
          sortDir: params.sortDir,
        },
      }),

    getById: (id: number) =>
      httpRequest<LookupItem>(`/v1/${basePath}/${id}`, { method: 'GET' }),

    create: (payload: LookupCreateUpdatePayload) =>
      httpRequest<LookupItem>(`/v1/${basePath}`, {
        method: 'POST',
        body: payload,
      }),

    update: (id: number, payload: LookupCreateUpdatePayload) =>
      httpRequest<LookupItem>(`/v1/${basePath}/${id}`, {
        method: 'PUT',
        body: payload,
      }),

    delete: (id: number) =>
      httpRequest<undefined>(`/v1/${basePath}/${id}`, { method: 'DELETE' }),
  }
}

export const employeeTypesApi = createLookupApi('employee-types')
export const driverLicensesApi = createLookupApi('driver-licenses')
export const militaryStatusesApi = createLookupApi('military-statuses')
export const jobDefinitionsApi = createLookupApi('job-definitions')
export const employeeStatusesApi = createLookupApi('employee-statuses')
